// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectInstrumentUpdateMessage } from "../../../../Utils/DirectMessages/DirectInstrumentUpdateMessage.js"
export let InstrumentUpdateMessageProcessor = function (decoder)
{
    MessageProcessorBase.call(this)
    this.decoder = decoder
}

InstrumentUpdateMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

InstrumentUpdateMessageProcessor.prototype.decode = function (fieldSet)
{
    let message = new DirectInstrumentUpdateMessage();

    let factory = FieldsFactory
    let decoder = this.decoder
    let symDecodeMap = decoder.InstrumentDecodeMap
    let tickId = -1

    let len = fieldSet.Count()
    for (let i = 0; i < len; i++)
    {
        let fixField = fieldSet.fieldSet[i];
        if (fixField.FieldId === 0)
            continue;

        if (fixField.FieldId === factory.FIELD_INSTRUMENT_ID)
        {
            tickId = fixField.Value;
            message.Name = symDecodeMap[tickId] || '';
            message.InstrumentID = tickId;
        }
        else if (fixField.FieldId === factory.FIELD_CONTRACT_ID)
        {
            message.ContractID = fixField.Value;
        }
        else if (fixField.FieldId === factory.FIELD_TRADE_SESSION_STATUS_ID)
        {
            message.TradeSessionStatusId = fixField.Value;
        }
        else if (fixField.FieldId === factory.FIELD_EXCHANGE_SESSION_NAME)
        {
            message.ExchangeSessionName = fixField.Value;
        }
        else if (fixField.FieldId === factory.FIELD_TRADABLE_INSTRUMENT_ID)
        {
            message.InstrumentTradableID = fixField.Value
        }
    }

    return [message];
}

